import Page from '@averyano/core/src/classes/Page';

export default class TermsPage extends Page {
	constructor() {
		super({
			element: '.terms',
			elements: {},
		});
	}

	create() {
		super.createComponent();
	}

	destroy() {
		super.destroy();
	}
}
